import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { Collapse, Spinner as ReactSpinner } from 'reactstrap';
import { Dayjs } from 'dayjs';

import { dateInputFieldFormat } from '~libs/dayjs';
import { useSearch } from '~libs/searchParams';

import { Button } from '~components';
import { SearchBar } from '~components/form-fields/search';
import Icon, { faMagnifyingGlass } from '~components/icon';
import WeekPicker from '~components/WeekPicker';
import searchFields from '~dashboard/components/user-calendar/forms/search';
import { update, updateParams } from '~dashboard/components/user-calendar/reducers/calendar';

import { selectLoading } from '../selectors/users';

interface ComponentProps {
  onRefresh?: (searchParams?: { repeat: boolean; sort: string[]; limit: number }) => void;
}

const Banner: React.FC<ComponentProps> = ({ onRefresh }) => {
  const dispatch = useAppDispatch();

  const initialSearchState: any = {};

  const [isSearchBarOpen, setIsSearchBarOpen] = useState<boolean>(false);

  const [searchParams, setSearchParams] = useSearch('search', initialSearchState);
  const search = (values: { [key: string]: any }) => setSearchParams(values);
  const calendarUserLoading = useAppSelector(selectLoading);

  const isLoading = calendarUserLoading === 'pending';

  const onDateChange = (value: Dayjs) => {
    const weekStart = value.weekday(0);

    dispatch(update({ date: value.format(dateInputFieldFormat) }));

    dispatch(
      updateParams({
        week_start: weekStart.format(dateInputFieldFormat),
        week_end: null,
      }),
    );
  };

  useEffect(() => {
    if (searchParams !== initialSearchState) {
      onRefresh?.(searchParams);
    }
  }, [searchParams]);

  return (
    <>
      <div className="nav d-flex justify-content-between bg-light p-2 mt-2 mb-2 banner">
        <div className="d-flex align-items-center ms-1">{isLoading && <ReactSpinner className="me-2" />}</div>
        <div className="d-flex">
          <WeekPicker onChange={onDateChange} />
          <Button size="sm" className="me-2" onClick={() => setIsSearchBarOpen(!isSearchBarOpen)}>
            <Icon className="me-2" icon={faMagnifyingGlass} />
            {isSearchBarOpen ? 'Hide' : 'Search'}
          </Button>
        </div>
      </div>
      <Collapse isOpen={isSearchBarOpen}>
        <SearchBar
          fields={searchFields}
          initialValues={searchParams}
          storageKey="dashboard-calendar"
          onSubmit={search}
        />
      </Collapse>
    </>
  );
};

export default Banner;
